var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c(
        "div",
        { staticClass: "login" },
        [
          _c(
            "div",
            { staticClass: "login-left" },
            [
              _c("div", { staticClass: "login-left--top" }, [
                _c("img", {
                  staticClass: "login-left--top__logo",
                  attrs: { src: _vm.loginLogoImgSrc }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "login-left-bg" }, [
                _c("img", {
                  staticClass: "login-left-bg-img",
                  attrs: { src: _vm.loginBgImgSrc }
                })
              ]),
              _vm._v(" "),
              _c(
                "ks-popover",
                { attrs: { placement: "bottom", trigger: "hover" } },
                [
                  _c("div", { staticClass: "mobile-wrapper" }, [
                    _c("img", {
                      staticClass: "mobile-logo",
                      attrs: { src: _vm.mobileDownLoadUrl[_vm.env] }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mobile-desc" }, [
                      _vm._v("扫码下载手机APP")
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { classs: "mobile-text" } }, [
                      _vm._v("快手本地商家")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: ["tips-item", "mobile-entry"],
                      attrs: { slot: "reference" },
                      slot: "reference"
                    },
                    [
                      _c(
                        "ks-button",
                        { attrs: { type: "primary", round: "" } },
                        [_vm._v("立即下载")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "login-left--bottom" }, [
                _c("h3", { staticClass: "login-left--bottom__title" }, [
                  _vm._v("快手本地商家APP")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "login-left--bottom__desc" }, [
                  _vm._v(" 便捷核销、及时收取消息、支持移动端代运营登录")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ks-dialog",
            {
              staticClass: "role-dialog",
              attrs: {
                title: "请选择商家身份",
                visible: _vm.showRoleList,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                "append-to-body": true,
                width: "640px",
                height: "666px"
              }
            },
            [
              _c("ks-input", {
                staticClass: "input",
                attrs: {
                  placeholder: "搜索商家名称/快手id/商家id",
                  "suffix-icon": "sys-icon-search",
                  clearable: ""
                },
                on: { change: _vm.searchRole },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { ref: "role-table_content", staticClass: "role-data" },
                [
                  _vm.singedMerchants.length !== 0
                    ? _c(
                        "div",
                        { ref: "role-table_cell" },
                        [
                          _vm._l(_vm.singedMerchants, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: item.merchantUserId,
                                staticClass: "role-data-item"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "role-data-item-left" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "role-data-item-left-top"
                                      },
                                      [_vm._v(_vm._s(item.merchantName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "role-data-item-left-bottom"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "快手id: " +
                                              _vm._s(item.merchantUserId)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass:
                                            "role-data-item-left-bottom-line"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            " 商家id: " +
                                              _vm._s(item.merchantId)
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ks-button",
                                  {
                                    staticClass: "role-data-item-btn",
                                    attrs: {
                                      type: "primary",
                                      plain: "!item.selected"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.submit(index)
                                      }
                                    }
                                  },
                                  [_vm._v("选择")]
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("div", {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.isLoading,
                                expression: "isLoading"
                              }
                            ],
                            staticClass: "loading"
                          })
                        ],
                        2
                      )
                    : _c("div", { staticClass: "role-empty" }, [
                        _c("img", {
                          staticClass: "emptyIcon",
                          attrs: {
                            src: require("@asset/images/empty_search.png"),
                            alt: "搜索无结果"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("搜索无结果")])
                      ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "role-paginagtion" },
                [
                  _c("ks-pagination", {
                    attrs: {
                      background: "",
                      layout: "total,prev, pager, next, jumper",
                      total: _vm.totalNum,
                      "page-size": 6
                    },
                    on: { "current-change": _vm.handlePageClick }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.accountTypeSelectShow
            ? _c("div", { staticClass: "login-right" }, [
                _c("div", { staticClass: "account-type-wrapper" }, [
                  _c("div", { staticClass: "title-container" }, [
                    _c("div", { staticClass: "title-left" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title-text" }, [
                      _vm._v("选择您登录的身份")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "account-type-item",
                        on: {
                          click: function($event) {
                            return _vm.accountTypeSelect(
                              _vm.EServePubAccountType.MainAccount
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "left-icon" }, [
                          _c("img", { attrs: { src: _vm.empolyer, alt: "" } })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                            我是商家/员工/我要入驻\n                            "
                          ),
                          _c("div", { staticClass: "sub-title" }, [
                            _vm._v("快手账号登录")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-icon" }, [
                          _c("i", {
                            staticClass: "ks-icon-arrow-right right-icon-class"
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "account-type-item",
                        on: {
                          click: function($event) {
                            return _vm.accountTypeSelect(
                              _vm.EServePubAccountType.SubAccount
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "left-icon" }, [
                          _c("img", { attrs: { src: _vm.empolyee, alt: "" } })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                            我是服务商/代运营\n                            "
                          ),
                          _c("div", { staticClass: "sub-title" }, [
                            _vm._v("手机验证码登录")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-icon" }, [
                          _c("i", {
                            staticClass: "ks-icon-arrow-right right-icon-class"
                          })
                        ])
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loginShow
            ? _c("div", { staticClass: "login-right" }, [
                _c("div", { staticClass: "login-form" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "welcome-wraper",
                        {
                          marginBottom:
                            _vm.accountType ===
                            _vm.EServePubAccountType.SubAccount
                              ? 48
                              : 0
                        }
                      ]
                    },
                    [
                      _c("h1", { staticClass: "login-header" }, [
                        _vm._v("欢迎您")
                      ]),
                      _vm._v(" "),
                      !_vm.isFromSmeargle
                        ? _c("div", { on: { click: _vm.closeLogin } }, [
                            _c("i", {
                              staticClass: "ks-icon-close close-icon-class"
                            })
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.accountType === _vm.EServePubAccountType.MainAccount
                    ? _c(
                        "div",
                        [
                          _c(
                            "ks-tabs",
                            {
                              on: { "tab-click": _vm.handleTabClick },
                              model: {
                                value: _vm.activeName,
                                callback: function($$v) {
                                  _vm.activeName = $$v
                                },
                                expression: "activeName"
                              }
                            },
                            [
                              !_vm.isFromSmeargle
                                ? _c(
                                    "ks-tab-pane",
                                    {
                                      attrs: {
                                        label: "扫码登录",
                                        name: "first"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "login-info" }, [
                                        _c(
                                          "div",
                                          { staticClass: "login-info--image" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "login-info--image__placeholder"
                                              },
                                              [
                                                _c("img", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.qrImgSrc,
                                                      expression: "qrImgSrc"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "login-info--image__qr",
                                                  attrs: { src: _vm.qrImgSrc }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    class: [
                                                      "login-info--image__logo",
                                                      _vm.expiredClass
                                                    ]
                                                  },
                                                  [
                                                    !_vm.isQRExpired
                                                      ? _c("img", {
                                                          staticClass:
                                                            "login-info--image__logo-kuai",
                                                          attrs: {
                                                            src: _vm.logoImgSrc
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "login-info--image__logo-refresh",
                                                          attrs: {
                                                            src:
                                                              _vm.refreshImgSrc
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleRefresh
                                                          }
                                                        })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isQRExpired,
                                                      expression: "isQRExpired"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "login-info--image__mask"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("img", {
                                              staticClass:
                                                "login-info--image__phone",
                                              attrs: { src: _vm.phoneImgSrc }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "login-info--desc" },
                                          [
                                            _vm._v(
                                              "\n                                    打开"
                                            ),
                                            _c("label", [_vm._v("快手APP")]),
                                            _vm._v(
                                              "点击「侧边栏」-「更多」-「扫一扫」\n                                "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "ks-tab-pane",
                                {
                                  attrs: { label: "验证码登录", name: "second" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "login-info" },
                                    [
                                      _c(
                                        "ks-form",
                                        {
                                          ref: "form",
                                          attrs: { model: _vm.form }
                                        },
                                        [
                                          _c(
                                            "ks-form-item",
                                            {
                                              class: [
                                                "login-item--phone",
                                                _vm.phoneErrorClass
                                              ]
                                            },
                                            [
                                              _c("ks-input", {
                                                attrs: {
                                                  type: "number",
                                                  placeholder:
                                                    _vm.form.phonePlaceholder,
                                                  clearable: ""
                                                },
                                                on: {
                                                  focus: _vm.handlerPhoneFocus,
                                                  input: _vm.handlerPhoneChange
                                                },
                                                model: {
                                                  value: _vm.form.phone,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "phone",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.phone"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.form.phoneErrorMsg,
                                                  expression:
                                                    "form.phoneErrorMsg"
                                                }
                                              ],
                                              staticClass: "login-item--error"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.form.phoneErrorMsg
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ks-form-item",
                                            {
                                              class: [
                                                "login-item--capcha",
                                                _vm.capchaFocusClass,
                                                _vm.capchaErrorClass
                                              ]
                                            },
                                            [
                                              _c(
                                                "ks-input",
                                                {
                                                  attrs: {
                                                    type: "number",
                                                    placeholder:
                                                      _vm.form.capchaPlaceholder
                                                  },
                                                  on: {
                                                    focus:
                                                      _vm.handlerCapchaFocus,
                                                    blur: _vm.handlerCapchaBlur,
                                                    input:
                                                      _vm.handlerCapchaChange
                                                  },
                                                  model: {
                                                    value: _vm.form.capcha,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "capcha",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.capcha"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: !_vm.form
                                                                .timer,
                                                              expression:
                                                                "!form.timer"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "login-item--capcha__send",
                                                          on: {
                                                            click:
                                                              _vm.handleCapcha
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    获取验证码\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: !!_vm.form
                                                                .timer,
                                                              expression:
                                                                "!!form.timer"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "login-item--capcha__timer"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    重新获取\n                                                    "
                                                          ),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "login-item--capcha__timer-num"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm.form
                                                                      .timer
                                                                  ) +
                                                                  "s\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.form.capchaErrorMsg,
                                                  expression:
                                                    "form.capchaErrorMsg"
                                                }
                                              ],
                                              staticClass: "login-item--error"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.form.capchaErrorMsg
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ks-form-item",
                                            [
                                              _c(
                                                "ks-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: _vm.handleSubmit
                                                  }
                                                },
                                                [_vm._v("登录")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.accountType === _vm.EServePubAccountType.SubAccount
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "login-info" },
                          [
                            _c(
                              "ks-form",
                              { ref: "form", attrs: { model: _vm.form } },
                              [
                                _c(
                                  "ks-form-item",
                                  {
                                    class: [
                                      "login-item--phone",
                                      _vm.phoneErrorClass
                                    ]
                                  },
                                  [
                                    _c("ks-input", {
                                      attrs: {
                                        type: "number",
                                        placeholder: _vm.form.phonePlaceholder,
                                        clearable: ""
                                      },
                                      on: {
                                        focus: _vm.handlerPhoneFocus,
                                        input: _vm.handlerPhoneChange
                                      },
                                      model: {
                                        value: _vm.form.phone,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "phone", $$v)
                                        },
                                        expression: "form.phone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.form.phoneErrorMsg,
                                        expression: "form.phoneErrorMsg"
                                      }
                                    ],
                                    staticClass: "login-item--error"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.form.phoneErrorMsg) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ks-form-item",
                                  {
                                    class: [
                                      "login-item--capcha",
                                      _vm.capchaFocusClass,
                                      _vm.capchaErrorClass
                                    ]
                                  },
                                  [
                                    _c(
                                      "ks-input",
                                      {
                                        attrs: {
                                          type: "number",
                                          placeholder:
                                            _vm.form.capchaPlaceholder
                                        },
                                        on: {
                                          focus: _vm.handlerCapchaFocus,
                                          blur: _vm.handlerCapchaBlur,
                                          input: _vm.handlerCapchaChange
                                        },
                                        model: {
                                          value: _vm.form.capcha,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "capcha", $$v)
                                          },
                                          expression: "form.capcha"
                                        }
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.form.timer,
                                                  expression: "!form.timer"
                                                }
                                              ],
                                              staticClass:
                                                "login-item--capcha__send",
                                              on: { click: _vm.handleCapcha }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            获取验证码\n                                        "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "append" }, [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!_vm.form.timer,
                                                  expression: "!!form.timer"
                                                }
                                              ],
                                              staticClass:
                                                "login-item--capcha__timer"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            重新获取\n                                            "
                                              ),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "login-item--capcha__timer-num"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.form.timer) +
                                                      "s "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.form.capchaErrorMsg,
                                        expression: "form.capchaErrorMsg"
                                      }
                                    ],
                                    staticClass: "login-item--error"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.form.capchaErrorMsg) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ks-form-item",
                                  [
                                    _c(
                                      "ks-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.handleSubmit }
                                      },
                                      [_vm._v("登录")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ks-dialog",
        {
          staticClass: "login-dialog",
          attrs: { title: "温馨提示", visible: _vm.showDialog },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "login-dialog--box" },
            [
              _c("span", { staticClass: "login-dialog--tip" }, [
                _vm._v(
                  "\n                此账号未开通店铺、暂时不支持在电脑端开店，您可以按下面流程在快手app上完成开店\n            "
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.dialogData, function(item) {
                return _c(
                  "div",
                  { key: item.title, staticClass: "login-dialog--step" },
                  [
                    _c("h1", { staticClass: "login-dialog--step__title" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      style: item.style,
                      attrs: { src: item.imgSrc }
                    })
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "login-dialog--box__bar" })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "login-dialog--bar",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "ks-dialog",
        {
          staticClass: "login-users--dialog",
          attrs: {
            title: "点击头像选择登录账号",
            visible: _vm.multiUserDialog.open,
            "show-close": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.multiUserDialog, "open", $event)
            }
          }
        },
        _vm._l(_vm.multiUserDialog.userInfos, function(user, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "login-users--content",
              on: {
                click: function($event) {
                  return _vm.handlerUserClick(user)
                }
              }
            },
            [
              _c("ks-avatar", {
                staticClass: "login-users--content__avatar",
                attrs: { src: user.headUrl, size: 48 }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "login-users--content__name" }, [
                _vm._v(_vm._s(user.name))
              ])
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }